import React, { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconQuotation: React.FC<PropsType> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M8.58905 17.8734C8.75942 18.0411 8.97053 18.125 9.22238 18.125H18.1113C18.3631 18.125 18.5742 18.0411 18.7446 17.8734C18.915 17.7057 19.0002 17.4979 19.0002 17.25C19.0002 17.0021 18.915 16.7943 18.7446 16.6266C18.5742 16.4589 18.3631 16.375 18.1113 16.375H9.22238C8.97053 16.375 8.75942 16.4589 8.58905 16.6266C8.41868 16.7943 8.3335 17.0021 8.3335 17.25C8.3335 17.4979 8.41868 17.7057 8.58905 17.8734Z'
        fill={iconFillColor}
      />
      <path
        d='M8.58905 12.6234C8.75942 12.7911 8.97053 12.875 9.22238 12.875H19.1113C19.3631 12.875 19.5742 12.7911 19.7446 12.6234C19.915 12.4557 20.0002 12.2479 20.0002 12C20.0002 11.7521 19.915 11.5443 19.7446 11.3766C19.5742 11.2089 19.3631 11.125 19.1113 11.125H9.22238C8.97053 11.125 8.75942 11.2089 8.58905 11.3766C8.41868 11.5443 8.3335 11.7521 8.3335 12C8.3335 12.2479 8.41868 12.4557 8.58905 12.6234Z'
        fill={iconFillColor}
      />
      <path
        d='M8.58905 7.37344C8.75942 7.54115 8.97053 7.625 9.22238 7.625H18.1113C18.3631 7.625 18.5742 7.54115 18.7446 7.37344C18.915 7.20573 19.0002 6.99792 19.0002 6.75C19.0002 6.50208 18.915 6.29427 18.7446 6.12656C18.5742 5.95885 18.3631 5.875 18.1113 5.875H9.22238C8.97053 5.875 8.75942 5.95885 8.58905 6.12656C8.41868 6.29427 8.3335 6.50208 8.3335 6.75C8.3335 6.99792 8.41868 7.20573 8.58905 7.37344Z'
        fill={iconFillColor}
      />
      <path
        d='M6.49844 18.4124C6.66615 18.242 6.75 18.0309 6.75 17.7791L6.75 5.89019C6.75 5.63834 6.66615 5.42723 6.49844 5.25686C6.33073 5.08649 6.12292 5.0013 5.875 5.0013C5.62708 5.0013 5.41927 5.08649 5.25156 5.25686C5.08385 5.42723 5 5.63834 5 5.89019L5 17.7791C5 18.0309 5.08385 18.242 5.25156 18.4124C5.41927 18.5828 5.62708 18.668 5.875 18.668C6.12292 18.668 6.33073 18.5828 6.49844 18.4124Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconQuotation;
